// extracted by mini-css-extract-plugin
export default {"h1":"AdLanding_h1__+K-js","titleContainer":"AdLanding_titleContainer__GD3Hr","referralDemo":"AdLanding_referralDemo__ocYvl"};